<template>
  <div class="convert-price" :style="styles">
  <svg-icon iconClass="shell" size="30" v-if="showIcon"></svg-icon>
    <span><span v-if="insignia" > </span><span>{{ convertPrice }}</span></span>
  </div>
</template>
<script>
export default {
  props: {
    styles: {
      type: Object,
      default: () => ({})
    },
    price: {
      type: [Number, String]
    },
    showIcon: { // 展示icon
      type: Boolean,
      default: true
    },
    insignia: { // 展示符号
      type: Boolean,
      default: true
    }
  },
  computed: {
    convertPrice () {
      return  this.price
      // return this.price.toLocaleString('vi-VN')
    }
  }
}
</script>
<style lang="scss" scoped>
  .convert-price{
    @include flex();
    width: fit-content;
    span{
      margin-left: 0.05rem;
      display: inline-block;
    }
  }
</style>